import Cookies from 'js-cookie';

/**
 * Class fetch calls for POST, GET, PATCH and DELETE (CRUD)
 * @class
 * @author Max Swinkels <max.swinkels@pangaea.nl>
 */
class ApiManager {
  constructor(options = {}) {
    this.config = {
      token: Cookies.get('token'),
      ...options
    };
  }

  post(url, data) {
    return this.request('POST', url, data);
  }

  get(url, accept = null) {
    return this.request('GET', url, null, accept);
  }

  patch(url, data) {
    return this.request('PATCH', url, data);
  }

  delete(url, data) {
    return this.request('DELETE', url, data);
  }

  request(method, url, body, accept) {
    const { token } = this.config;
    const { lang } = document.querySelector('body').dataset;

    // Default headers
    const headers = new Headers({
      'Accept-Language': lang.length ? lang.toLowerCase() : 'nl',
      'Content-Type': 'application/json'
    });

    if (token) {
      headers.append('Authorization', `Bearer ${token}`); // checks if client is logged in to add header Authorization
    }

    if (accept) {
      headers.append('Accept', accept); // add accept header if it has been entered with the 'GET' method. for example for retrieving an html template
    }

    const options = {
      method,
      cache: 'no-cache',
      mode: 'cors',
      headers
    };

    if (body) {
      options.body = JSON.stringify(body); // stringify all data variables
    }

    // handle response, format in contentType and return to fetch API call
    const handleResponse = response => {
      if (response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.indexOf('application/json') !== -1) {
          return response.json();
        }
        return response.text();
      }
      return Promise.reject(response);
    };

    return fetch(url, options)
      .then(handleResponse)
      .then(responseData => responseData);
  }
}

export default ApiManager;
